import { ImageScaleView, ViewOpts } from '@play-co/timestep-core/ui';
import Match2TournamentResultItem from './Match2TournamentResultItem';
import { getTournamentRankImage } from './match2-tournament.utils';

export default class Match2TournamentResultRank extends Match2TournamentResultItem {
  constructor(opts: ViewOpts, label: string) {
    super(opts, label);

    new ImageScaleView({
      superview: this,
      image: getTournamentRankImage('streak'),
      width: 148,
      height: 148,
      centerOnOrigin: true,
      scaleMethod: 'contain',
      x: 4,
      y: 14,
    });
  }

  public showRank(rank: number) {
    this.enable();
    this.label.updateOpts({ color: '#FFF50B' });
    this.label.localeText = () => rank.toString();
    this.label.show();
    this.show();
  }
}
